import _ from 'lodash';
import React from 'react';
import useSWR from 'swr';
import { swrGoFetcher } from 'utils/go_api';
const { createContext, useContext, useState, useEffect } = React;

export const LaunchDataContext = createContext({});
LaunchDataContext.displayName = 'LaunchData';

export const LaunchDataProvider = (props) => {
  const { children } = props;

  const { data, error, isLoading, isValidating, mutate } = useSWR(
    '/api/v1/homepage/launch-data',
    (url) => swrGoFetcher(url)
  );

  const activityTags = _.get(data, 'activity_tags', []) || [];
  const categoryTree = _.get(data, 'category_tree', []) || {};
  const factorTypes = _.get(data, 'factor_types', []) || [];
  const ingredientSafeties = _.get(data, 'ingredient_safeties', []) || [];
  const ingredientFeatures = _.get(data, 'ingredient_features', []) || [];
  const productFacts = _.get(data, 'product_facts', []) || [];
  const productOrigins = _.get(data, 'product_origins', []) || [];
  const reviewTags = _.get(data, 'review_tags', []) || [];
  // const reviewOptions = _.get(data, 'review_options', {}) || {};
  // const searchSkinProblemKeywords =
  //   _.get(data, 'search_skin_problem_keywords', []) || [];
  // const campaigns = _.get(data, 'campaigns', []) || [];
  const notifications = _.get(data, 'notifications', []) || [];
  const stores = _.get(data, 'stores', []) || [];
  const reviewSources = _.get(data, 'review_sources', []) || [];
  // const contentCounts = _.get(data, 'content_counts', null) || {
  //   product_count: 0,
  //   review_count: 0,
  //   category_count: 0,
  // };

  const firstCategoryMap = _.reduce(
    categoryTree,
    (acc, firstCategory) => {
      acc[firstCategory.id] = firstCategory;
      return acc;
    },
    {}
  );

  const secondCategories = _.reduce(
    categoryTree,
    (acc, firstCategory) => {
      return acc.concat(firstCategory.second_categories);
    },
    []
  );

  const secondCategoryMap = _.reduce(
    categoryTree,
    (acc, firstCategory) => {
      const secondCategories = firstCategory.second_categories;
      _.forEach(secondCategories, (secondCategory) => {
        acc[secondCategory.id] = secondCategory;
      });
      return acc;
    },
    {}
  );

  const activityTagMap = _.reduce(
    activityTags,
    (acc, tag) => {
      acc[tag.id] = tag;
      return acc;
    },
    {}
  );

  // const campaignMap = _.reduce(
  //   campaigns,
  //   (acc, campaign) => {
  //     acc[campaign.id] = campaign;
  //     return acc;
  //   },
  //   {}
  // );

  const factors = _.reduce(
    factorTypes,
    (acc, factorType) => {
      return acc.concat(factorType.factors);
    },
    []
  );

  const factorMap = _.reduce(
    factors,
    (acc, factorType) => {
      acc[factorType.id] = factorType;
      return acc;
    },
    {}
  );

  const storeMap = _.reduce(
    stores,
    (acc, store) => {
      acc[store.id] = store;
      return acc;
    },
    {}
  );

  const productOriginMap = _.reduce(
    productOrigins,
    (acc, origin) => {
      acc[origin.id] = origin;
      return acc;
    },
    {}
  );

  const ingredientSafetyMap = _.keyBy(ingredientSafeties, 'id');
  const ingredientFeatureMap = _.keyBy(ingredientFeatures, 'id');
  const reviewSourceMap = _.keyBy(reviewSources, 'id');
  const reviewTagMap = _.keyBy(reviewTags, 'id');

  return (
    <LaunchDataContext.Provider
      value={{
        isLoading,
        categoryTree,
        secondCategories,
        // searchSkinProblemKeywords,
        firstCategoryMap,
        secondCategoryMap,
        activityTagMap,
        factorTypes,
        factorMap,
        // reviewOptions,
        reviewSources,
        reviewSourceMap,
        reviewTags,
        reviewTagMap,
        // campaignMap,
        stores,
        storeMap,
        productFacts,
        productOrigins,
        productOriginMap,
        notifications,
        ingredientSafeties,
        ingredientSafetyMap,
        ingredientFeatures,
        ingredientFeatureMap,
        // contentCounts,
      }}
    >
      {children}
    </LaunchDataContext.Provider>
  );
};

export const useLaunchData = () => {
  return useContext(LaunchDataContext);
};
